<template>
<div>
  <!-- Header Area Starts -->
  <header class="single-page header-middle" style="position: relative; z-index: 1;">
    <div class="header-top" :style="'padding:0px; flex: 0; background: #306FBA; transition: width .3s ease-in-out; margin-bottom: 16 px; margin-bottom: 0; color: #fff; font-size: 14px; width: 100%; z-index: 9999;box-shadow: 0 2px 9px 0 #e1e2e7; min-height: 60px;' + menuStyle">
      <div class="container" style="max-width: 90%;">
        <div class="row" style="margin: 0 auto;">
          <div class="col-lg-2">
            <div class="logo-area" v-if="headLeft">
              <div v-html="headLeft"></div>
              <!-- <h4 style="display: flex; flex-direction: row; justify-content: space-between; align-items: cente;color: #FFF; font-size: 28px; width: 280px;">
                <img src="./assets/logo.png" style="width: 56px;"/>
                <div style="position: relative;top: 30px; font-size: 28px; font-family: Heiti SC;">56LIUPI出海导航</div>
              </h4> -->
            </div>
          </div>
          <div class="col-lg-10">
            <div class="custom-navbar">
            </div>
            <div class="main-menu main-menu-light">
              <ul v-if="headMenuList && headMenuList.length > 0" style="float: left; margin-left: 80px; vertical-align: middle; margin-top: 14px;">
                 <li>
                  <router-link to="/" :class="{ active: $route.path === '/' }">首页</router-link>
                </li>
                <li v-for="(tab, index) in headMenuList" :key="index">
                  <router-link 
                    :to="{name: 'menu', query: {id: tab.id, title: tab.title}}" 
                    :class="{ active: $route.name === 'menu' && $route.query.id == tab.id }">
                    {{tab.title}}
                  </router-link>
                </li>
              </ul>
              <ul v-if="headRight" style="float: right;">
                <li v-html="headRight"></li>
                <!-- <li><img src="./assets/head2.png" style="width: 74px;"/></li>
                <li style="display: inline-flex; padding-left: 20px;">
                  联系方式:18606535729<br/>
                  联系方式:15361660396
                </li> -->
                <!-- <li><router-link to="/about">关于我们</router-link></li> -->
                <!-- <li v-if="username"><router-link to="/my">个人中心</router-link></li> -->
                <!-- <li v-if="username"><router-link :to="{name:'my',query:{menuType:'HotelOrder'}}">我的订单</router-link></li> -->
                <!-- <li class="menu-btn" v-if="!username">
                  <el-dialog title="登陆/注册" center append-to-body width="30%" :visible.sync="loginVisible">
                    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" style="padding: 10px; padding-bottom: 0px;">
                      <el-form-item label="用户名" prop="username">
                        <el-input v-model="loginForm.username" placeholder="请输入用户名" size="small" prefix-icon="el-icon-user"></el-input>
                      </el-form-item>
                      <el-form-item label="密码" prop="password">
                        <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" size="small" prefix-icon="el-icon-lock" :show-password=true></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-button :loading="loginLoading" size="medium" type="primary" round @click.native.prevent="handleLogin" style="width:100%;">
                          <span v-if="!loginLoading">登 录</span>
                          <span v-else>登 录 中...</span>
                        </el-button>
                        <div style="text-align: center;">or</div>
                        <el-button size="medium" round @click.stop="$router.push('register')" style="width:100%;">
                          <span>注 册 </span>
                        </el-button>
                      </el-form-item>
                      <el-form-item>
                        <span>没有账号？</span>
                        <span style="color: #ff9902;cursor: pointer;font-weight: 600;" @click.stop="$router.push('register')">注册</span>
                        <span style="color: #ff9902; cursor: pointer; position: absolute; right: 0px">忘记密码?</span>
                      </el-form-item>
                    </el-form>
                  </el-dialog>
                  <el-link type="primary" style="color: #ef6c00; cursor: pointer;" @click="loginVisible = true">登录</el-link>
                </li> -->
                <!-- <li class="menu-btn" v-else>
                  <el-popover placement="bottom" width="300" trigger="click" v-model="loginVisible">
                    <div style="padding-bottom: 8px;margin-bottom: 8px;border-bottom: 1px solid #e1e2e7;">
                      <h4 style="color: #676f86; margin: 0; font-size:14px;">账户信息</h4>
                      <div style="color: #1f2b4b; padding:10px;">{{username}}</div>
                    </div>
                    <div style="padding-bottom: 8px;margin-bottom: 8px;border-bottom: 1px solid #e1e2e7;">
                      <h4 style="color: #676f86; margin: 0; font-size:14px;">授信额度</h4>
                      <div style="color: #1f2b4b; padding:10px;">
                        {{balance||'0.00'}}
                        <span style="color:#ef6c00;margin-left: 175px;">查看明细</span>
                      </div>
                    </div>
                    <div style="margin-top: 20px; margin-bottom: 8px; text-align: center;">
                      <el-button slot="reference" type="primary" @click.stop="logout">退出</el-button>
                    </div>
                    <el-link type="primary" slot="reference" style="font-size: 16px;font-weight: 600;color: #ef6c00; cursor: pointer;">{{username}}</el-link>
                  </el-popover>
                </li> -->
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <!-- Header Area End -->
  <!-- <keep-alive> -->
    <router-view if=isRouterAlive :key="$route.fullPath"></router-view>
  <!-- </keep-alive> -->

  <!-- News Letter Start -->
  <!-- <div class="newsletter-bg">
    <div class="container">
      <div class="newsletter">
        <div class="newsletter-inner text-center text-lg-left">
          <div class="row justify-content-center align-items-center">
            <div class=" col-xl-10 col-12">
              <div class="row align-items-center">
                <div class="col-xl-6 col-lg-6">
                  <div class="d-lg-flex align-items-center">
                    <div class="newsletter-icon"><img src="static/picture/subscribe_icon.svg" alt="TravelRide"></div>
                    <div class="newsletter-title color-white">
                      <h2 class="main_title mb-0">更多咨讯 & More</h2>
                      <p class="m-0">输入邮箱地址，获取更多咨讯</p>
                    </div>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6">
                  <form>
                    <div class="newsletter-box">
                      <input type="email" placeholder="请输入您的邮箱地址...">
                      <button title="Subscribe" class="btn btn-color">提交</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <!-- News Letter End -->
  <!-- FOOTER START -->
  <div class="footer color-white" style="background: #306FBA;">
    <div class="container">
      <div class="footer-inner">
        <div class="footer-middle">
          <div class="row">
            <div class="col-lg-3 col-md-6 f-col">
              <div class="footer-static-block">
                <div class="f-logo mb-30 mb-sm-15">
                  <a href="" class="">
                    <h3 class="title"><img src="./assets/logo2.png" style="border-radius: 5px;" alt="鑫跃物流"><span></span></h3>
                  </a>
                </div>
                <div class="footer-about mb-sm-30">
                  <p>鑫跃物流是获得中国政府批准的合法经营国际快递、国内国际空运的专业化国际快递服务公司。并成为DHL中外运敦豪、TNT天地物流、美国UPS联合包裹美国FEDEX联邦快递、SAGAWA日本佐川急便等知名国际快递的一级代理商。</p>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 f-col">
              <div class="footer-static-block"> <span class="opener plus"></span>
                <h3 class="title">我们的服务<span></span></h3>
                <ul class="footer-block-contant link">
                  <li>专业小程序定制，精准报价。微信咨询，即刻获取个性化方案与详细报价！</li>
                  <li>
                    <img src="./assets/xcx.png" style="border-radius: 5px; width: 100px;" alt="鑫跃物流">
                    <img src="./assets/wx.jpg" style="border-radius: 5px; width: 100px;" alt="鑫跃物流">
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 f-col">
              <div class="footer-static-block"> <span class="opener plus"></span>
                <h3 class="title">产品服务<span></span></h3>
                <div class="footer-block-contant">
                  <ul class="tagcloud">
                    <li><a href="javascript:void(0)" style="background: rgb(140, 197, 255); cursor: text;">国际快递: DHL UPS FEDEX EMS等国际快递代理服务</a></li>
                    <li><a href="javascript:void(0)" style="background: rgb(140, 197, 255); cursor: text;">国际空运: EK EY CZ SQ MU CA PO CX 等航订舱服务</a></li>
                    <li><a href="javascript:void(0)" style="background: rgb(140, 197, 255); cursor: text;">国际海运:APL CMA COSCO EMC HMM MSK等 海运订舱服务</a></li>
                    <li><a href="javascript:void(0)" style="background: rgb(140, 197, 255); cursor: text;">国际专线:东南亚海陆空专线  欧美海陆空专线等</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 f-col">
              <div class="footer-static-block"> <span class="opener plus"></span>
                <h3 class="title">联系信息<span></span></h3>
                <div class=" footer-block-contant ">
                  <ul class="address">
                     <li class="item">
                      <div class="address-icon icon1">
                        <i class="el-icon-location-outline" style="font-size: 22px; color: #FFF; position: absolute;"/>
                      </div>
                      <p class="address">仓库地址:中国广东省深圳市宝安区福永街道凤凰社区商西区 19-25 号仓库</p>
                    </li>
                    <li class="item">
                      <div class="address-icon icon1">
                        <i class="el-icon-location-outline" style="font-size: 22px; color: #FFF; position: absolute;"/>
                      </div>
                      <p class="address">办公室地址:中国广东省深圳市宝安区福永街道凤凰社区合一智慧港写字楼二栋 702 室</p>
                    </li>
                    <li>
                      <div class="address-icon icon2">
                        <i class="el-icon-phone-outline" style="font-size: 22px; color: #FFF; position: absolute;"/>
                      </div>
                      <p>电话:18060535729 15361660396</p>
                    </li>
                    <li>
                      <div class="address-icon icon3">
                        <i class="el-icon-eleme" style="font-size: 22px; color: #FFF; position: absolute;"/>
                      </div>
                      <p>邮箱:yt@szxy56.com xystyt@qq.com</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom text-center" style="border-top: 1px solid #FFF;">
          <div class="copy-right-bg">
            <div class="container">
              <div class="row align-center">
                <div class="col-12">
                  <div class="copy-right ">Copyright &copy;2024深圳市鑫跃顺通国际物流有限公司 | <a href="https://beian.miit.gov.cn" style="color:#FFF;">粤ICP备2024302030号</a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="scroll-top">
    <div class="scrollup"></div>
  </div>
  <!-- FOOTER END -->
</div>
</template>
<script>
import {listHead} from './api/index'
export default {
  name: 'app',
  provide () {
    reload: this.reload
  },
  data () {
    return {
      // 登录框
      loginVisible: false,
      // 控制router-view的显示或隐藏，从而控制页面的再次加载
      isRouterAlive: true,
      // 登录表单
      loginForm: {
        username: '',
        password: ''
      },
      // 登录规则
      loginRules: {
        username: [
          { required: true, trigger: 'blur', message: '用户名不能为空' }
        ],
        password: [
          { required: true, trigger: 'blur', message: '密码不能为空' }
        ]
      },
      // 登录loading
      loginLoading: false,
      // 登录显示框
      loginVisible: false,
      username: '',
      balance: 0.00,
      // 是否显示酒店Banner图
      isShowHotelBanner: false,
      // 是否显示Footer
      isShowHotelFooter: true,
      // top样式
      menuStyle: '',
      // banner样式
      bannerStyle: '',
      toolName: '',
      headLeft: '',
      headRight: '',
      headMenuList: [],
    }
  },
  created() {
    this.username = window.localStorage.getItem("userName")
    this.getUserInfo()
    this.listHead()
  },
  methods: {
    async listHead () {
      let response = await listHead()
      const _this = this
      if (response && response.code === 0 && response.data) {
        let headList = response.data
        if(headList && headList.length) {
          headList.forEach(head => {
            // 1-中间菜单 2-顶部左侧 3-顶部右侧
            if (head.contentType == 2) {
              _this.headLeft = head.content
            } else if (head.contentType == 3) {
              _this.headRight = head.content
            } else {
              _this.headMenuList.push(head)
            }
          })
          console.log('_this.headMenuList: ' + JSON.stringify(_this.headMenuList))
        }
      } else {
        this.$message.error(response.msg)
      }
    },
    reload () {
      this.isRouterAlive = false;
      this.$nextTick(function(){
        this.isRouterAlive = true;
      });
    },
    // 登录
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loginLoading = true
          console.log("登录 请求体=" +JSON.stringify(this.loginForm))
          this.$http({
              url: process.env.API_HOST + "/portal/cusCustomer/login",
              method: 'post',
              data: this.loginForm
            }).then(({data}) => {
              if (data && data.code === 0) {
                console.log("登录=" +JSON.stringify(data))
                this.$store.commit('common/updateId', data.data.userId)
                this.$store.commit('common/updateName', data.data.username)
                this.$store.commit('set_token', data.data.token)
                window.localStorage.setItem("userId", data.data.userId)
                window.localStorage.setItem("userName", data.data.username)
                window.localStorage.setItem("token", data.data.token)

                console.log(window.localStorage.getItem("userId") +", " + window.localStorage.getItem("userName")+", "+ window.localStorage.getItem("token"))
                /// this.username = data.data.username
                this.$message({message: '登录成功', type: 'success'})
                location.reload()
              } else {
                this.loginLoading = false
                this.loginVisible = false
                this.$message.error(data.msg)
              }
            })
        }
      })
    },
    // 查询用户信息
    getUserInfo () {
      let userId = window.localStorage.getItem("userId");
      if(userId) {
        this.$http({
          url: process.env.API_HOST + '/portal/cusCustomer/getInfo/' + userId,
          method: 'get'
        }).then(({data}) => {
          console.log("查询用户信息: "+JSON.stringify("data"))
          if (data && data.code === 0) {
            this.balance = data.data.balance
          }
        })
      }
    },
    // 退出登录
    logout () {
      this.loginLoading = false
      this.loginVisible = false
      localStorage.removeItem("userId")
      localStorage.removeItem("userName")
      localStorage.removeItem("token")
      this.username = "";
      this.$router.push("/")
    }
  }
}

// 日期格式化
Date.prototype.Format = function (fmt) { //author: meizz
  var o = {
      "M+": this.getMonth() + 1,               //月份
      "d+": this.getDate(),                    //日
      "h+": this.getHours(),                   //小时
      "m+": this.getMinutes(),                 //分
      "s+": this.getSeconds(),                 //秒
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度
      "S": this.getMilliseconds()             //毫秒
  };
  if (/(y+)/.test(fmt))
      fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}
</script>
<style>
.el-button--primary {
  color: #fff !important;
  background: #409EFF;
  border: 1px solid #409EFF;
}
.el-button--primary:hover {
  color: #fff !important;
  background: #111;
}
.el-button--primary:visited {
  color: #fff !important;
  background: #111;
}
.el-button--primary:active {
  color: #fff !important;
  background: #111;
}
.main-menu.main-menu-light a {
  color: #FFF;
}
.router-link-exact-active {
  border-bottom: 2px solid #409EFF;
}
.el-tabs__item.is-active {
  color: #409EFF !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active  {
  background-color: #409EFF!important;
}
.el-form-item {
  margin-bottom: 0px!important;
}
.el-dialog__body .el-form-item {
  margin-bottom: 22px!important;
}
.container-fluid .el-form-item {
  margin-bottom: 22px!important;
}
.text-ellipsis{
  overflow:hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// App.vue?b1cb99ec